import { createRequestAction } from '../../Helpers/Action.helpers';
import { REQUEST_ACTIONS } from '../../Constants/Actions.constants';
import { USER_SERVICE_URLS } from '../../Constants/Urls.constants';
import { AuthModel } from '../../Models/DTO/Auth.model';

export interface RegisterData {
  new_user: NewUser;
}
export interface NewUser {
  email: string;
  password: string;
  password_confirmation: string;
  first_name: string;
  last_name: string;
}

export const requestSignup = (data: RegisterData) =>
  createRequestAction<AuthModel>({
    name: REQUEST_ACTIONS.SIGNUP,
    url: USER_SERVICE_URLS.REGISTER,
    method: 'POST',
    data,
  });

export type SignupAction = typeof requestSignup;
// # Password Reset Action
export interface PasswordReset {
  email: string;
  src_url: string;
}

export interface ResetData {
  password_reset: PasswordReset;
}

export const requestResetPassword = (data: ResetData) =>
  createRequestAction<AuthModel>({
    name: REQUEST_ACTIONS.PASSWORD_RESET,
    url: USER_SERVICE_URLS.PASSWORD_RESET,
    method: 'POST',
    data,
  });

export type ResetPasswordAction = typeof requestResetPassword;

// # New Password Action
export interface NewPassword {
  password: string;
  password_confirmation: string;
  reset_password_token: string;
}

export interface NewPasswordData {
  password: NewPassword;
}

export const requestNewPassword = (data: NewPasswordData) =>
  createRequestAction<AuthModel>({
    name: REQUEST_ACTIONS.NEW_PASSWORD,
    url: USER_SERVICE_URLS.NEW_PASSWORD,
    method: 'PATCH',
    data,
  });

export type NewPasswordAction = typeof requestNewPassword;
